// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"7308c518","470":"cb044269"}[chunkId] + ".chunk.js";
};